import { TextField } from '@mui/material';
import NewDemographicValue from './NewDemographicValue';
import DemographicValuesAlias from './DemographicValuesAlias';
import { DemographicCategory, DemographicValue } from '../../../interfaces/EOAInterface';
import { Dispatch, SetStateAction, memo } from 'react';

interface DemographicCategoryConfigProps {
    categoryName: string;
    category: DemographicCategory;
    setCategory: Dispatch<SetStateAction<DemographicCategory>>;
    defaultCategoryValues?: DemographicValue[];
    newValueOption?: boolean;
}

const MemoizedDemographicCategoryConfig = memo(function DemographicCategoryConfig({category, setCategory, categoryName, defaultCategoryValues, newValueOption = true}: DemographicCategoryConfigProps) {

  const handleChangeCategoryValueDistrictName = (e: { target: { value: string; }}, index: number) => {
    setCategory((prev) => {
      const prevValues = [...prev.demographic_values];
      prevValues[index] = {...prevValues[index], district_name: e.target.value};
      return { ...prev, demographic_values: prevValues };
    });
  };

  return (
    <>
      <h3>{categoryName}</h3>
      <h4>Category District Name</h4>
      <TextField
        placeholder="District Name"
        variant="outlined"
        value={category.district_name}
        onChange={(e) => setCategory((prev) => ({...prev, district_name: e.target.value}))}
      />
      <h4>Category Values District Names</h4>
      {category.demographic_values.map((value, index) => (
        <TextField
          key={index}
          placeholder={`${value} District Name`}
          variant="outlined"
          value={value.district_name}
          onChange={(e) => handleChangeCategoryValueDistrictName(e, index)}
        />
      ))}
      {newValueOption ?
        <NewDemographicValue
          label={categoryName}
          category={category}
          setCategory={setCategory}
          defaultCategoryValues={defaultCategoryValues}
        />
        :
        null
      }
      <DemographicValuesAlias
        label={categoryName}
        category={category}
        setCategory={setCategory}
      />
    </>
  );
});

export default MemoizedDemographicCategoryConfig;